import { App } from 'vue'
import {
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Button,
  Alert,
  Message
} from 'heywhale-ui'

export default {
  install(app: App) {
    app
      .component('Form', Form)
      .component('FormItem', FormItem)
      .component('Input', Input)
      .component('Select', Select)
      .component('Option', Option)
      .component('Button', Button)
      .component('Alert', Alert)
      .component('Message', Message)
  }
}
